/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
// BASE Components
import BASESvgIcon from "../../../../../../@BASE/core/BASESvgIcon";
// Material UI
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

function EmptyFieldArray(props) {
  const { message } = props;

  return (
    <Paper className="flex flex-col flex-auto p-24 py-64 shadow rounded-xl overflow-hidden items-center justify-center">
      <BASESvgIcon size={32}>
        heroicons-outline:exclamation
      </BASESvgIcon>
      <Typography className="text-lg font-medium mt-16">
        {message}
      </Typography>
    </Paper>
  );
}

export default EmptyFieldArray;
